import { render, staticRenderFns } from "./Module5.vue?vue&type=template&id=073cfcdf&"
import script from "./Module5.vue?vue&type=script&lang=js&"
export * from "./Module5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports